export enum DTEntityTypes {
  DTDealServiceContractsTableRequestResult = 'DTDealServiceContractsTableRequestResult',
  DTDealGapSourcesTableRequestResult = 'DTDealGapSourcesTableRequestResult',
  DTDealPDICompaniesTableRequestResult = 'DTDealPDICompaniesTableRequestResult',
  DTDealAddsToCostTableRequestResult = 'DTDealAddsToCostTableRequestResult',
  DTDealTaxGroupTableRequestResult = 'DTDealTaxGroupTableRequestResult',
}

export type DTWSDLEntityName = keyof typeof DTEntityTypes;

export enum FormattedCategory {
  ACCESSORY = 'Accessory',
  ADD_TO_COST = 'Add to Cost',
  AFTERMARKET_OPTION = 'Aftermarket Option',
  GAP_INSURANCE = 'Gap Insurance',
  LEASING_FEE = 'Leasing Fee',
  LENDING_FEE = 'Lending Fee',
  NOT_AVAILABLE = 'N/A',
  PHYSICAL_DAMAGE_INSURANCE = 'Physical Damage Insurance',
  SERVICE_CONTRACT = 'Service Contract',
}

/**
 * Used for consumption on the front end.  A more human friendly DTE.
 */
export type FormattedDTE = {
  id: string;
  name: string;
  category: FormattedCategory;
  dtType: DTWSDLEntityName;
  cost?: string | null;
};
